import { useDispatch, useSelector } from "react-redux";
import { NextBtn } from "../buttons/nextBtn/NextBtn";
import { PrevBtn } from "../buttons/prevBtn/PrevBtn";
import { Modal } from "../modal/Modal";
import { QuestionsContainer } from "../questionsContainer/QuestionsContainer";
import { useEffect, useState } from "react";
import {
  resetInitialState,
  setIsCookieModalShown,
  setIsModalShown,
} from "../../redux/globalFunctions";
import { resetForm } from "../../redux/companyForm";
import { resetAnswers } from "../../redux/answers";
import { resetAnsweredQuestions } from "../../redux/answeredQuestions";
import translations from "../../en.json";
import translationsNo from "../../no.json";
import { ChooseLangModal } from "../chooseLangModal/ChooseLangModal";
import { ProgressBar } from "../progressBar/ProgressBar";
import { CookieElement } from "../cookieElement/CookieElement";
import { CookiesModal } from "../cookiesModal/CookiesModal";
import evinityLogo from "../../images/evinityLogo.svg";

export function Quiz() {
  const {
    isModalShown,
    quizFinished,
    language,
    isLangModalShown,
    currentLevel,
    areCompanyQuestionsShown,
    isCookieModalShown,
    cookies,
  } = useSelector((state) => state.global);
  const companyForm = useSelector((state) => state.companyForm);
  const { answers } = useSelector((state) => state.answers);
  const { questions } = useSelector((state) => state.answeredQuestions);
  const dispatch = useDispatch();
  const [percentage, setPercentage] = useState(0);

  // Show modal if there is data present to restore or to start over the quiz.
  useEffect(() => {
    const areStringsEmpty = Object.values(companyForm).every(
      (value) => value === ""
    );
    const areAnswersEmpty = Object.keys(answers).length === 0;

    if (
      quizFinished ||
      (areStringsEmpty && areAnswersEmpty && !areCompanyQuestionsShown)
    ) {
      dispatch(setIsModalShown(false));
      dispatch(resetInitialState());
      dispatch(resetForm());
      dispatch(resetAnswers());
      dispatch(resetAnsweredQuestions());
    } else {
      dispatch(setIsModalShown(true));
    }
  }, []);

  // Function to calculate the percentage of questions answered.
  useEffect(() => {
    if (questions) {
      const answeredCount = Object.keys(questions).length;
      const totalQuestions = 16;
      const completedPercentage = (answeredCount / totalQuestions) * 100;
      setPercentage(parseFloat(completedPercentage.toFixed(1)));
    }
  }, [questions]);

  // Function to check cookies on the first load
  useEffect(() => {
    if (cookies?.levelTracking === null && cookies?.ipTracking === null) {
      dispatch(setIsCookieModalShown(true));
    }
  }, [cookies?.levelTracking, cookies?.ipTracking]);

  const pageText = language === "en" ? translations.quiz : translationsNo.quiz;

  const firstLevelTitle = (
    <>
      <div>{pageText.description.firstLevel.header}</div>
      <br />
      <div>{pageText.description.firstLevel.intro}</div>
      {pageText.description.firstLevel.benefits.map((item, index) => (
        <div key={index}> - {item}</div>
      ))}
      <br />
      <div>{pageText.description.firstLevel.pro_tip}</div>
      <br />
      <div>{pageText.description.firstLevel.conclusion}</div>
    </>
  );

  const allOtherLevelsTitle = (
    <>
      <div className="header">{pageText.description.allOtherLevels.header}</div>
      <br />
      <div className="tip">{pageText.description.allOtherLevels.pro_tip}</div>
    </>
  );

  return (
    <div className="quiz-container">
      <CookieElement />
      {isModalShown && <Modal />}
      {isCookieModalShown && !isLangModalShown && !isModalShown && (
        <CookiesModal />
      )}
      {isLangModalShown && !isModalShown && <ChooseLangModal />}
      <div className="logo-container">
        <div className="evolveLogoContainer"></div>
        <img src={evinityLogo} alt="" />
        <div className="aviloLogoContaier">
          <img
            className="aviloLogo"
            src="https://cdn.bitrix24.com/b29539777/landing/cc6/cc696e234f088df04a7034a0558b47a3/logo_2_1x.png"
            alt={pageText.logoAltText}
          />
        </div>
      </div>
      <div className="quiz-title">{pageText.title}</div>
      <div className="quiz-description">
        {currentLevel === -1 ? firstLevelTitle : allOtherLevelsTitle}
      </div>
      {currentLevel === 1 && <ProgressBar width={percentage} />}
      <QuestionsContainer />
      <div className="navigation-buttons">
        <PrevBtn />
        <NextBtn />
      </div>
    </div>
  );
}
